/* Deankeating.co pixel, verified on Shoelace Ads. Never include application PII. */
(() => {
  'use strict';
  if (window.dkVisibilityTrackingInstalled) return;
  window.dkVisibilityTrackingInstalled = true;
  const PIXEL = '1296604341802387';
  const FUNNELS = {
    '/pages/google-ai-visibility-system': { slug: 'google-ai-visibility-system', name: 'Google + AI Visibility System' },
    '/pages/websites-for-tradesmen': { slug: 'websites-for-tradesmen', name: 'Websites for Tradesmen — Google + AI Visibility' }
  };
  const funnel = FUNNELS[location.pathname];
  const isFunnel = Boolean(funnel);
  const store = {
    get(key) { try { return JSON.parse(sessionStorage.getItem('dkvis:' + key)); } catch (_) { return null; } },
    set(key, value) { try { sessionStorage.setItem('dkvis:' + key, JSON.stringify(value)); } catch (_) {} }
  };
  const uuid = () => crypto.randomUUID();
  const pageId = uuid();
  const pendingEvents = new Map();
  const sent = new Set();
  let initialized = false;
  let ready = false;
  const allowed = () => window.Shopify?.customerPrivacy?.marketingAllowed() === true;
  function startPixel() {
    if (initialized || !allowed()) return;
    if (!window.fbq) {
      const n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!window._fbq) window._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      const script = document.createElement('script');
      script.async = true; script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    // Reuse a target pixel already initialised in the same window.
    const existing = window.fbq.getState?.().pixels?.some(p => String(p.id) === PIXEL);
    if (!existing) {
      window.fbq('set', 'autoConfig', false, PIXEL);
      window.fbq('init', PIXEL);
    }
    initialized = true;
  }
  function flush() {
    if (!ready || !allowed()) return;
    startPixel();
    for (const [key, item] of pendingEvents) {
      if (sent.has(key) || (item.once && store.get('sent:' + key))) { pendingEvents.delete(key); continue; }
      window.fbq(item.custom ? 'trackSingleCustom' : 'trackSingle', PIXEL, item.name, item.data, { eventID: key });
      sent.add(key);
      if (item.once) store.set('sent:' + key, true);
      pendingEvents.delete(key);
    }
  }
  function track(name, id, once = false) {
    const data = isFunnel ? { content_name: funnel.name, content_category: funnel.slug } : {};
    pendingEvents.set(id, { name, data, once, custom: false });
    flush();
  }
  function trackCustom(name, id, once = false) {
    const data = isFunnel ? { content_name: funnel.name, content_category: funnel.slug } : {};
    pendingEvents.set(id, { name, data, once, custom: true });
    flush();
  }
  track('PageView', 'page-' + pageId);
  if (isFunnel) track('ViewContent', 'view-' + pageId);
  function consentReady() { ready = true; flush(); }
  document.addEventListener('visitorConsentCollected', () => {
    if (initialized) window.fbq('consent', allowed() ? 'grant' : 'revoke');
    consentReady();
  });
  if (window.Shopify?.customerPrivacy) consentReady();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) consentReady(); });

  if (!isFunnel) return;
  const vsl = document.getElementById('combined-vsl');
  if (vsl) {
    vsl.addEventListener('play', () => trackCustom('VSLPlay', 'vsl-play-' + pageId, true), { once: true });
    const milestones = new Set();
    vsl.addEventListener('timeupdate', () => {
      if (!Number.isFinite(vsl.duration) || vsl.duration <= 0) return;
      const progress = (vsl.currentTime / vsl.duration) * 100;
      for (const threshold of [25, 50, 75]) {
        if (progress >= threshold && !milestones.has(threshold)) {
          milestones.add(threshold);
          trackCustom('VSL' + threshold, 'vsl-' + threshold + '-' + pageId, true);
        }
      }
    });
    vsl.addEventListener('ended', () => trackCustom('VSLComplete', 'vsl-complete-' + pageId, true), { once: true });
  }
  const form = document.getElementById('visibility-application');
  const success = document.getElementById('vis-application-accepted');
  const booking = document.getElementById('vis-booking');
  const sourceParams = new URLSearchParams(location.search);
  const attribution = {};
  // Only campaign attribution, never name, email, phone or application responses.
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
    const value = sourceParams.get(key);
    if (value) attribution[key] = value.slice(0, 200);
  }
  const campaign = Object.keys(attribution).length ? attribution : (store.get('campaign') || {});
  if (Object.keys(attribution).length) store.set('campaign', campaign);
  if (form && !success) {
    for (const [key, value] of Object.entries(campaign)) {
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'contact[' + key + ']'; input.value = value; form.appendChild(input);
    }
    form.addEventListener('submit', () => {
      // Native browser validation precedes this event. Submission alone is NOT a Lead.
      let pending = store.get('application');
      if (!pending || Date.now() - pending.at > 1800000 || pending.accepted) pending = { id: uuid(), at: Date.now() };
      store.set('application', pending);
    });
  }
  if (success && booking) {
    const pending = store.get('application');
    // Require both Shopify's rendered success AND this tab's recent submission.
    if (pending && Date.now() - pending.at < 1800000) {
      track('Lead', 'application-' + pending.id, true);
      pending.accepted = true; store.set('application', pending);
    }
    if (success.dataset.qualificationRoute !== 'qualified') return;
    const url = new URL('https://calendly.com/deanokeating-1/ai-business-coach');
    url.searchParams.set('embed_domain', location.hostname);
    url.searchParams.set('embed_type', 'Inline');
    url.searchParams.set('utm_campaign', campaign.utm_campaign || funnel.slug);
    for (const [key, value] of Object.entries(campaign)) url.searchParams.set(key, value);
    const iframe = document.createElement('iframe');
    iframe.title = 'Book your 30-minute call with Dean Keating';
    iframe.src = url.href;
    iframe.style.cssText = 'width:100%;height:850px;border:0;background:white;border-radius:12px';
    booking.appendChild(iframe);
    window.addEventListener('message', event => {
      if (event.origin !== 'https://calendly.com' || event.source !== iframe.contentWindow) return;
      if (event.data?.event !== 'calendly.event_scheduled') return;
      const uri = event.data.payload?.event?.uri;
      if (typeof uri !== 'string' || !/^https:\/\/api\.calendly\.com\/scheduled_events\/[a-zA-Z0-9-]+$/.test(uri)) return;
      const bookingId = uri.split('/').pop();
      track('Schedule', 'booking-' + bookingId, true);
      const status = document.getElementById('vis-booked-status');
      if (status) { status.hidden = false; status.textContent = 'Your call is booked. Calendly will email your confirmation and appointment details.'; }
    });
  }
})();
